<template>
    <div>
        <CustomFormItem
            v-for="(item, idx) in comps"
            :key="idx"
            :value="datas[item.props.name]"
            :widget="item"
            :verifyInfo="verifyInfo[item.props.name] || {}"
            :rules="rules ? rules[item.props.name] : []"
            :validation="validation"
            :inline="inline"
            @change="changeHandler(item, $event)"
            @verify="verifyHandler(item, $event)"
        />
    </div>
</template>

<script>
import CustomFormItem from "./widgets/FormItem.vue";

export default {
    name: "FormRender",
    components: {
        CustomFormItem
    },
    props: ["formData", "comps", "verifyInfo", "rules", "validation", "inline"],
    computed: {
        datas() {
            return this.formData || {};
        }
    },
    methods: {
        changeHandler(item, newItemData) {
            const newData = { ...this.datas, [item.props.name]: newItemData };
            this.$emit("change", newData);
        },
        verifyHandler(item, info) {
            const newVerifyInfo = { ...this.verifyInfo };
            newVerifyInfo[item.props.name] = info;
            this.$emit("verify", newVerifyInfo);
        }
    }
};
</script>
